import { render, staticRenderFns } from "./CustomTimeBubble.vue?vue&type=template&id=20495c2f&lang=html"
import script from "./CustomTimeBubble.vue?vue&type=script&lang=js"
export * from "./CustomTimeBubble.vue?vue&type=script&lang=js"
import style0 from "./CustomTimeBubble.vue?vue&type=style&index=0&id=20495c2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports